import { render, staticRenderFns } from "./AnimatedEllipsis.vue?vue&type=template&id=88c14a24&scoped=true&"
var script = {}
import style0 from "./AnimatedEllipsis.css?vue&type=style&index=0&id=88c14a24&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88c14a24",
  null
  
)

export default component.exports